import * as React from 'react';
import { useState } from 'react';
import Slider from 'rc-slider';
import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import { __ } from 'react-i18n';
import { FlexColCenter, FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';

interface Props {
  tolarance: number;
  setTolerance: (value: number) => void;
}

export function MapZoom({ tolarance = 30, setTolerance }: Props) {
  const handleSliderChange = value => {
    setTolerance(Number(value));
  };

  return (
    <Wrapper>
      <StyledP>{__('Tolerancia')}</StyledP>
      <StyledSlider
        min={0}
        max={120}
        value={tolarance}
        onChange={handleSliderChange}
        railStyle={{
          height: `${rem(4)}`,
          background: `${({ theme }) => rgba(theme.colors.primary)}`,
        }}
        handleStyle={{
          height: `${rem(16)}`,
          width: `${rem(16)}`,
          marginLeft: `${rem(0)}`,
          marginTop: `${rem(-6)}`,
          backgroundColor: '#F9F9F9',
          border: `${({ theme }) => `4px solid ${theme.colors.primary}`}`,
        }}
        trackStyle={{
          background: `${({ theme }) => theme.colors.primary}`,
        }}
      />
      <StrongStyledP>{tolarance} km</StrongStyledP>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)`
  margin-bottom: ${rem(44)};
`;

const StyledSlider = styled(Slider)`
  max-width: ${rem(302)};
`;

const textLikeCss = css`
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
  min-width: ${rem(56)};
  margin: 0 ${rem(24)};
`;

const StyledP = styled.p`
  ${textLikeCss};
`;

const StrongStyledP = styled(StyledP)`
  font-weight: 500;
`;
